export function getDiscordLoginBroadcastChannel() {
  return new BroadcastChannel("discord-login");
}
